import { LitElement, html } from 'lit-element';
import { styles } from './uc-footer-menu-item.styles';

export class UcFooterMenuItem extends LitElement {
  static get styles() {
    return styles;
  }

  render() {
    return html`
      <uc-button class="menu-item">
        <slot></slot>
      </uc-button>
    `;
  }
}
